module.exports = __webpack_public_path__ + "static/img/xiazailuxiang2.938bf2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/xiazailuxiang2.png
// module id = uWM+
// module chunks = 24